import { ChangeDetectionStrategy, Component, inject, input, signal } from "@angular/core";
import { IonIcon, IonTitle, IonToolbar } from "@ionic/angular/standalone";
import { addIcons } from "ionicons";
import { closeCircleOutline, informationCircleOutline, warningOutline } from "ionicons/icons";
import { AlertDialogComponent } from "@intocare-medapp/design-system";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { SunsetWarning } from "../shared";

const WARNING_COLOR = {
	LOW: "secondary",
	MODERATE: "tertiary",
	HIGH: "warning",
	CRITICAL: "danger",
} satisfies Record<SunsetWarning["level"], string>;

const WARNING_ICON = {
	LOW: "information-circle-outline",
	MODERATE: "information-circle-outline",
	HIGH: "warning-outline",
	CRITICAL: "close-circle-outline",
} satisfies Record<SunsetWarning["level"], string>;

@Component({
	selector: "ic-app-sunset-banner",
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [IonToolbar, IonTitle, IonIcon, AlertDialogComponent, TranslatePipe],
	templateUrl: "./app-sunset-banner.component.html",
	host: {
		class: "ion-display-block",
		role: "alert",
		"[attr.aria-live]": "'polite'",
		"[attr.aria-label]": "ariaLabel()",
	},
})
export class AppSunsetBannerComponent {
	readonly dataWarning = input.required<SunsetWarning | undefined>();

	protected readonly warningColor = (warning: SunsetWarning) => WARNING_COLOR[warning.level];
	protected readonly warningIcon = (warning: SunsetWarning) => WARNING_ICON[warning.level];

	protected readonly isMoreInfoModalOpen = signal<boolean>(false);
	protected readonly ariaLabel = toSignal(inject(TranslateService).stream("appSunsetBanner.a11yName"));

	constructor() {
		addIcons({ informationCircleOutline, warningOutline, closeCircleOutline });
	}
}
